import { render, staticRenderFns } from "./VueTemplateEditor.vue?vue&type=template&id=6fa9bdfa&scoped=true&"
import script from "./VueTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./VueTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueTemplateEditor.vue?vue&type=style&index=0&id=6fa9bdfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9bdfa",
  null
  
)

export default component.exports